import { useState, useEffect } from 'react';

export function useUndoableDelete({ onDeleteApi, onUndoApi, delay = 5000 }) {
  const [undoItem, setUndoItem] = useState(null);
  const [showUndo, setShowUndo] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);
  const [remainingTime, setRemainingTime] = useState(Math.floor(delay / 1000));

  useEffect(() => {
    let interval;
    if (showUndo) {
      setRemainingTime(Math.floor(delay / 1000));
      interval = setInterval(() => {
        setRemainingTime(prev => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [showUndo, delay]);

  const triggerDelete = (item) => {
    setUndoItem(item);
    setShowUndo(true);

    const id = setTimeout(async () => {
      try {
        await onDeleteApi(item);
      } catch (err) {
        console.error('❌ Failed to delete:', err);
      } finally {
        setShowUndo(false);
        setUndoItem(null);
      }
    }, delay);

    setTimeoutId(id);
  };

  const triggerUndo = async () => {
    if (timeoutId) clearTimeout(timeoutId);
    try {
      await onUndoApi(undoItem);
    } catch (err) {
      console.error('❌ Failed to undo:', err);
    } finally {
      setShowUndo(false);
      setUndoItem(null);
    }
  };

  return {
    undoItem,
    showUndo,
    triggerDelete,
    triggerUndo,
    remainingTime,
  };
}